import { v4, validate } from 'uuid';

export const uuid = v4;

export const isUuid = (value: string): boolean => validate(value);
